// ContactForm.js
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import confetti from 'canvas-confetti';
import { Form, Input, Select, Button, Tabs, Spin, Alert, Radio,message  } from 'antd';


// import 'antd/dist/reset.css' in your app root

const { Option } = Select;
const { TabPane } = Tabs;

const COUNTRY_CODES = [
  { code: "+93", name: "Afghanistan" },
  { code: "+355", name: "Albania" },
  { code: "+213", name: "Algeria" },
  { code: "+376", name: "Andorra" },
  { code: "+244", name: "Angola" },
  { code: "+1-268", name: "Antigua and Barbuda" },
  { code: "+54", name: "Argentina" },
  { code: "+374", name: "Armenia" },
  { code: "+297", name: "Aruba" },
  { code: "+61", name: "Australia" },
  { code: "+43", name: "Austria" },
  { code: "+994", name: "Azerbaijan" },
  { code: "+1-242", name: "Bahamas" },
  { code: "+973", name: "Bahrain" },
  { code: "+880", name: "Bangladesh" },
  { code: "+1-246", name: "Barbados" },
  { code: "+375", name: "Belarus" },
  { code: "+32", name: "Belgium" },
  { code: "+501", name: "Belize" },
  { code: "+229", name: "Benin" },
  { code: "+1-441", name: "Bermuda" },
  { code: "+975", name: "Bhutan" },
  { code: "+591", name: "Bolivia" },
  { code: "+387", name: "Bosnia and Herzegovina" },
  { code: "+267", name: "Botswana" },
  { code: "+55", name: "Brazil" },
  { code: "+673", name: "Brunei" },
  { code: "+359", name: "Bulgaria" },
  { code: "+226", name: "Burkina Faso" },
  { code: "+257", name: "Burundi" },
  { code: "+855", name: "Cambodia" },
  { code: "+237", name: "Cameroon" },
  { code: "+1", name: "Canada" },
  { code: "+238", name: "Cape Verde" },
  { code: "+1-345", name: "Cayman Islands" },
  { code: "+236", name: "Central African Republic" },
  { code: "+235", name: "Chad" },
  { code: "+56", name: "Chile" },
  { code: "+86", name: "China" },
  { code: "+57", name: "Colombia" },
  { code: "+269", name: "Comoros" },
  { code: "+682", name: "Cook Islands" },
  { code: "+506", name: "Costa Rica" },
  { code: "+385", name: "Croatia" },
  { code: "+53", name: "Cuba" },
  { code: "+599", name: "Curaçao" },
  { code: "+357", name: "Cyprus" },
  { code: "+420", name: "Czech Republic" },
  { code: "+243", name: "DR Congo" },
  { code: "+45", name: "Denmark" },
  { code: "+253", name: "Djibouti" },
  { code: "+1-767", name: "Dominica" },
  { code: "+670", name: "East Timor" },
  { code: "+593", name: "Ecuador" },
  { code: "+20", name: "Egypt" },
  { code: "+503", name: "El Salvador" },
  { code: "+240", name: "Equatorial Guinea" },
  { code: "+291", name: "Eritrea" },
  { code: "+372", name: "Estonia" },
  { code: "+251", name: "Ethiopia" },
  { code: "+500", name: "Falkland Islands" },
  { code: "+298", name: "Faroe Islands" },
  { code: "+679", name: "Fiji" },
  { code: "+358", name: "Finland" },
  { code: "+33", name: "France" },
  { code: "+594", name: "French Guiana" },
  { code: "+689", name: "French Polynesia" },
  { code: "+241", name: "Gabon" },
  { code: "+220", name: "Gambia" },
  { code: "+995", name: "Georgia" },
  { code: "+49", name: "Germany" },
  { code: "+233", name: "Ghana" },
  { code: "+350", name: "Gibraltar" },
  { code: "+30", name: "Greece" },
  { code: "+299", name: "Greenland" },
  { code: "+1-473", name: "Grenada" },
  { code: "+590", name: "Guadeloupe" },
  { code: "+1-671", name: "Guam" },
  { code: "+502", name: "Guatemala" },
  { code: "+224", name: "Guinea" },
  { code: "+245", name: "Guinea-Bissau" },
  { code: "+592", name: "Guyana" },
  { code: "+509", name: "Haiti" },
  { code: "+504", name: "Honduras" },
  { code: "+852", name: "Hong Kong" },
  { code: "+36", name: "Hungary" },
  { code: "+354", name: "Iceland" },
  { code: "+91", name: "India" },
  { code: "+62", name: "Indonesia" },
  { code: "+98", name: "Iran" },
  { code: "+964", name: "Iraq" },
  { code: "+353", name: "Ireland" },
  { code: "+972", name: "Israel" },
  { code: "+39", name: "Italy" },
  { code: "+1-876", name: "Jamaica" },
  { code: "+81", name: "Japan" },
  { code: "+962", name: "Jordan" },
  { code: "+7", name: "Kazakhstan" },
  { code: "+254", name: "Kenya" },
  { code: "+686", name: "Kiribati" },
  { code: "+383", name: "Kosovo" },
  { code: "+965", name: "Kuwait" },
  { code: "+996", name: "Kyrgyzstan" },
  { code: "+856", name: "Laos" },
  { code: "+371", name: "Latvia" },
  { code: "+961", name: "Lebanon" },
  { code: "+266", name: "Lesotho" },
  { code: "+231", name: "Liberia" },
  { code: "+218", name: "Libya" },
  { code: "+423", name: "Liechtenstein" },
  { code: "+370", name: "Lithuania" },
  { code: "+352", name: "Luxembourg" },
  { code: "+853", name: "Macau" },
  { code: "+389", name: "North Macedonia" },
  { code: "+261", name: "Madagascar" },
  { code: "+265", name: "Malawi" },
  { code: "+60", name: "Malaysia" },
  { code: "+960", name: "Maldives" },
  { code: "+223", name: "Mali" },
  { code: "+356", name: "Malta" },
  { code: "+692", name: "Marshall Islands" },
  { code: "+596", name: "Martinique" },
  { code: "+222", name: "Mauritania" },
  { code: "+230", name: "Mauritius" },
  { code: "+262", name: "Mayotte" },
  { code: "+52", name: "Mexico" },
  { code: "+691", name: "Micronesia" },
  { code: "+373", name: "Moldova" },
  { code: "+377", name: "Monaco" },
  { code: "+976", name: "Mongolia" },
  { code: "+382", name: "Montenegro" },
  { code: "+1-664", name: "Montserrat" },
  { code: "+212", name: "Morocco" },
  { code: "+258", name: "Mozambique" },
  { code: "+95", name: "Myanmar" },
  { code: "+264", name: "Namibia" },
  { code: "+674", name: "Nauru" },
  { code: "+977", name: "Nepal" },
  { code: "+31", name: "Netherlands" },
  { code: "+687", name: "New Caledonia" },
  { code: "+64", name: "New Zealand" },
  { code: "+505", name: "Nicaragua" },
  { code: "+227", name: "Niger" },
  { code: "+234", name: "Nigeria" },
  { code: "+683", name: "Niue" },
  { code: "+850", name: "North Korea" },
  { code: "+1-670", name: "Northern Mariana Islands" },
  { code: "+47", name: "Norway" },
  { code: "+968", name: "Oman" },
  { code: "+92", name: "Pakistan" },
  { code: "+680", name: "Palau" },
  { code: "+970", name: "Palestine" },
  { code: "+507", name: "Panama" },
  { code: "+675", name: "Papua New Guinea" },
  { code: "+595", name: "Paraguay" },
  { code: "+51", name: "Peru" },
  { code: "+63", name: "Philippines" },
  { code: "+48", name: "Poland" },
  { code: "+351", name: "Portugal" },
  { code: "+1-787", name: "Puerto Rico" },
  { code: "+974", name: "Qatar" },
  { code: "+242", name: "Republic of the Congo" },
  { code: "+262", name: "Réunion" },
  { code: "+40", name: "Romania" },
  { code: "+7", name: "Russia" },
  { code: "+250", name: "Rwanda" },
  { code: "+590", name: "Saint Barthélemy" },
  { code: "+290", name: "Saint Helena" },
  { code: "+1-869", name: "Saint Kitts and Nevis" },
  { code: "+1-758", name: "Saint Lucia" },
  { code: "+590", name: "Saint Martin" },
  { code: "+685", name: "Samoa" },
  { code: "+378", name: "San Marino" },
  { code: "+239", name: "Sao Tome and Principe" },
  { code: "+966", name: "Saudi Arabia" },
  { code: "+221", name: "Senegal" },
  { code: "+381", name: "Serbia" },
  { code: "+248", name: "Seychelles" },
  { code: "+232", name: "Sierra Leone" },
  { code: "+65", name: "Singapore" },
  { code: "+1-721", name: "Sint Maarten" },
  { code: "+421", name: "Slovakia" },
  { code: "+386", name: "Slovenia" },
  { code: "+677", name: "Solomon Islands" },
  { code: "+252", name: "Somalia" },
  { code: "+27", name: "South Africa" },
  { code: "+82", name: "South Korea" },
  { code: "+211", name: "South Sudan" },
  { code: "+34", name: "Spain" },
  { code: "+94", name: "Sri Lanka" },
  { code: "+249", name: "Sudan" },
  { code: "+597", name: "Suriname" },
  { code: "+268", name: "Swaziland" },
  { code: "+46", name: "Sweden" },
  { code: "+41", name: "Switzerland" },
  { code: "+963", name: "Syria" },
  { code: "+886", name: "Taiwan" },
  { code: "+992", name: "Tajikistan" },
  { code: "+255", name: "Tanzania" },
  { code: "+66", name: "Thailand" },
  { code: "+228", name: "Togo" },
  { code: "+690", name: "Tokelau" },
  { code: "+676", name: "Tonga" },
  { code: "+1-868", name: "Trinidad and Tobago" },
  { code: "+216", name: "Tunisia" },
  { code: "+90", name: "Turkey" },
  { code: "+993", name: "Turkmenistan" },
  { code: "+1-649", name: "Turks and Caicos Islands" },
  { code: "+688", name: "Tuvalu" },
  { code: "+1-340", name: "U.S. Virgin Islands" },
  { code: "+256", name: "Uganda" },
  { code: "+380", name: "Ukraine" },
  { code: "+971", name: "United Arab Emirates" },
  { code: "+44", name: "United Kingdom" },
  { code: "+1", name: "United States" },
  { code: "+598", name: "Uruguay" },
  { code: "+998", name: "Uzbekistan" },
  { code: "+678", name: "Vanuatu" },
  { code: "+379", name: "Vatican City" },
  { code: "+58", name: "Venezuela" },
  { code: "+84", name: "Vietnam" },
  { code: "+681", name: "Wallis and Futuna" },
  { code: "+212", name: "Western Sahara" },
  { code: "+967", name: "Yemen" },
  { code: "+260", name: "Zambia" },
  { code: "+263", name: "Zimbabwe" }
];


const QUALIFICATIONS = ['B.Tech', 'M.Tech', 'Master Of Science - MS', 'Degree', 'MBA'];
const BRANCHES_BY_QUAL = {
  'B.Tech': ['Cyber Security', 'Data Science', 'Artificial Intelligence & Machine Learning', 'CSE/IT', 'ECE', 'Others'],
  'M.Tech': ['Cyber Security', 'Data Science', 'Artificial Intelligence & Machine Learning', 'CSE/IT', 'ECE', 'Others'],
  'Master Of Science - MS': ['Cyber Security', 'Data Science', 'Artificial Intelligence & Machine Learning', 'CSE/IT', 'ECE', 'Others'],
  'Degree': ['B.SC', 'B.Com'],
  'MBA': ['MBA'],
};
const DOMAINS = ['IT', 'Non-IT'];

function validateEmail(email) {
  return /^\S+@\S+\.\S+$/.test(email);
}
function onlyDigits(str) {
  return (str || '').replace(/\D/g, '');
}

// Convert DD-MM-YYYY -> YYYY-MM-DD (ISO-ish) or return original trimmed
function toIsoDate(dateStr) {
  if (!dateStr && dateStr !== 0) return null;
  const s = String(dateStr).trim();
  if (/^\d{2}-\d{2}-\d{4}$/.test(s)) {
    const [dd, mm, yyyy] = s.split('-');
    return `${yyyy}-${mm}-${dd}`;
  }
  // if it's a timestamp-like or ISO already, return it
  return s;
}

// Normalize BatchDay into exact tokens we expect (MORNING / EVENING) or empty
function normalizeBatchDay(val) {
  if (!val && val !== 0) return '';
  let s = String(val).trim().toUpperCase();
  // keep only alpha chars (handle stray spaces / punctuation)
  s = s.replace(/[^A-Z]/g, '');
  // if contains MOR or EVE etc, map heuristically
  if (s.includes('MORN') || s === 'M' || s === 'AM') return 'MORNING';
  if (s.includes('EVE') || s === 'E' || s === 'PM') return 'EVENING';
  if (s === 'MORNING' || s === 'EVENING') return s;
  return s; // return whatever uppercase we have (may be '')
}

export default function FormGoogleJunior() {
  const [form] = Form.useForm();
  const [countryCode, setCountryCode] = useState('+91');
  // const [submittedData, setSubmittedData] = useState(null);
  // const [submitting, setSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState('student');

  // API-driven batches
  const [batches, setBatches] = useState([]); // full batch objects
  const [loadingBatches, setLoadingBatches] = useState(false);
  const [batchesError, setBatchesError] = useState(null);

  // filter
  const [batchDayFilter, setBatchDayFilter] = useState('MORNING');

  // selected batch key kept in state for reliable UI highlight
  const [selectedBatchKey, setSelectedBatchKey] = useState(undefined);

  // months we want: current + 2
  const wantedMonthKeys = useMemo(() => [0, 1, 2].map(i => dayjs().add(i, 'month').format('YYYY-MM')), []);

  // fetch and normalize rows
  useEffect(() => {
    let mounted = true;
    async function load() {
      setLoadingBatches(true);
      setBatchesError(null);
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/demolinks/all-demolinks`, { mode: 'cors' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        const rows = Array.isArray(json.data) ? json.data : [];

        // group rows by YYYY-MM (use BatchStartDate -> DemoDate)
        const monthMap = new Map();
        for (const r of rows) {
          // determine grouping date (prefer BatchStartDate else DemoDate)
          const groupingIso = toIsoDate(r.BatchStartDate ?? r.DemoDate ?? r.DemoDate); // handle possible nulls
          if (!groupingIso) continue;
          const d = dayjs(groupingIso);
          if (!d.isValid()) continue;
          const key = d.format('YYYY-MM');

          const normalized = {
            ...r,
            __groupIso: groupingIso,
            __groupDayjs: d,
            __batchStartIso: toIsoDate(r.BatchStartDate ?? r.DemoDate ?? groupingIso),
            // normalize from any field that might contain the day token
            __batchDayNorm: normalizeBatchDay(r.BatchDay ?? r.batchDay ?? r.Day ?? ''),
            __timeRaw: (r.BatchTime ?? r.Time ?? '').toString(),
          };

          if (!monthMap.has(key)) monthMap.set(key, []);
          monthMap.get(key).push(normalized);
        }

        // build computed batches for wanted months
        const computed = wantedMonthKeys.map((key) => {
          const monthRows = monthMap.get(key) || [];
          if (!monthRows.length) return null;

          // pick representative (earliest date)
          monthRows.sort((a, b) => (a.__groupDayjs.isBefore(b.__groupDayjs) ? -1 : 1));
          const rep = monthRows[0];

          return {
            key,
            label: dayjs(rep.__batchStartIso).isValid() ? dayjs(rep.__batchStartIso).format('MMM YYYY') : key,
            time: rep.__timeRaw || 'TBD',
            batchStartIso: rep.__batchStartIso,
            batchStartDateRaw: rep.BatchStartDate ?? rep.DemoDate ?? rep.__batchStartIso,
            batchDay: rep.__batchDayNorm || '',
            representativeId: rep.id ?? null,
            rawRows: monthRows,
          };
        }).filter(Boolean);

        if (mounted) {
          setBatches(computed);
        }
      } catch (err) {
        console.error('load demo links error', err);
        if (mounted) setBatchesError(err.message || 'Failed to load');
      } finally {
        if (mounted) setLoadingBatches(false);
      }
    }
    load();
    return () => { mounted = false; };
  }, [wantedMonthKeys]);

  // displayed batches based on filter (check any rawRows' __batchDayNorm)
  const displayedBatches = useMemo(() => {
    const f = String(batchDayFilter || '').trim().toUpperCase();
    if (!f) return [];

    const normalizeRowDay = (r) => normalizeBatchDay(r.__batchDayNorm ?? r.BatchDay ?? r.batchDay ?? r.Day ?? '');

    return batches
      .map(b => {
        if (!Array.isArray(b.rawRows) || !b.rawRows.length) return null;

        const matchedRow = b.rawRows.find(r => {
          const v = normalizeRowDay(r);
          return String(v).trim().toUpperCase() === f;
        });

        if (!matchedRow) return null;

        return {
          key: b.key,
          label: b.label,
          time: matchedRow.__timeRaw || b.time || 'TBD',
          batchStartIso: matchedRow.__batchStartIso || b.batchStartIso,
          batchStartDateRaw: matchedRow.BatchStartDate ?? matchedRow.DemoDate ?? b.batchStartDateRaw,
          batchDay: normalizeRowDay(matchedRow) || b.batchDay || '',
          representativeId: matchedRow.id ?? b.representativeId ?? null,
          rawRows: b.rawRows,
          __matchedRow: matchedRow,
        };
      })
      .filter(Boolean);
  }, [batches, batchDayFilter]);

  useEffect(() => {
    // sync selection to first visible when filter changes
    const cur = form.getFieldValue('batch');
    const visibleKeys = displayedBatches.map(b => b.key);
    let toSelect = cur;
    if (!visibleKeys.includes(cur)) {
      toSelect = visibleKeys.length ? visibleKeys[0] : undefined;
      form.setFieldsValue({ batch: toSelect });
    }
    setSelectedBatchKey(toSelect);
  }, [displayedBatches, form]);

  // clear irrelevant tab fields when switching tabs (optional but helps validation)
  useEffect(() => {
    if (activeTab === 'student') {
      form.setFieldsValue({ domain: undefined, sector: undefined, yearsOfExperience: undefined, companyName: undefined });
    } else {
      form.setFieldsValue({ qualification: undefined, branch: undefined, collegeName: undefined, passedOutYear: undefined });
    }
  }, [activeTab, form]);

  // helper to set batch both in form and state
  const setBatchSelection = (key) => {
    form.setFieldsValue({ batch: key });
    setSelectedBatchKey(key);
  };

 const onFinish = async (values) => {
  // Prevent double submit if already submitting
  // if (submitting) return;
  // setSubmitting(true);

  // Show SweetAlert2 loading modal
  Swal.fire({
    title: 'Please wait…',
    html: 'Submitting your registration...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    const all = { ...form.getFieldsValue(true), ...values };
    const selectedKey = all.batch ?? selectedBatchKey;

    // prefer displayedBatch (so BatchDay/time match UI)
    const visibleBatch = (Array.isArray(displayedBatches) && displayedBatches.find(b => b.key === selectedKey))
      || (Array.isArray(displayedBatches) && displayedBatches[0])
      || null;
    const rawBatch = visibleBatch || (batches.find(b => b.key === selectedKey) || null);

    const availability = rawBatch ? {
      key: rawBatch.key,
      label: rawBatch.label,
      time: rawBatch.time ?? (rawBatch.__matchedRow?.__timeRaw) ?? 'TBD',
      batchStartIso: rawBatch.batchStartIso ?? rawBatch.__matchedRow?.__batchStartIso ?? null,
      batchStartDateRaw: rawBatch.batchStartDateRaw ?? (rawBatch.__matchedRow?.BatchStartDate ?? rawBatch.__matchedRow?.DemoDate) ?? null,
      batchDay: rawBatch.batchDay ?? (rawBatch.__matchedRow ? normalizeBatchDay(rawBatch.__matchedRow.__batchDayNorm ?? rawBatch.__matchedRow.BatchDay ?? '') : ''),
      representativeId: rawBatch.representativeId ?? (rawBatch.__matchedRow?.id ?? null),
    } : null;

    const selectedBatchDay = availability?.batchDay || '';

    const payload = {
      FullName: (all.fullName || '').trim(),
      Email: (all.email || '').trim(),
      PhoneNumber: `${all.countryCode || countryCode || '+91'} ${onlyDigits(all.phone || '')}`,
      LeadCategory: activeTab,
      LeadSource: 'GOOGLE',
      EnrollmentType: 'JUNIOR PENETRATION TESTER',
      

      ...(activeTab === 'student'
        ? {
            // Qualification: all.qualification || '',
            // Branch: all.branch || '',
            CollegeName: all.collegeName || '',
            PassedOutYear: all.passedOutYear || '',
          }
        : {
            // Domain: all.domain || '',
            // Sector: all.sector || '',
            YearsOfExperience: all.yearsOfExperience || '',
            CompanyName: all.companyName || '',
          }),

      // send availability iso (or change to full object if needed)
      AvailabilityBatch: availability ? availability.batchStartIso : null,
      BatchDay: selectedBatchDay,
      CallBack: (all.requestCallback || 'NO'),
    };

    // Decide endpoint
    const endpoint = activeTab === 'student'
      ?  `${process.env.REACT_APP_API_URL}/leads/form-student`
      : `${process.env.REACT_APP_API_URL}/leads/form-professional`;

    // POST using axios
    const res = await axios.post(endpoint, payload, {
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // optional antd toast
    // message.success('Form submitted successfully.');
    

    // Save both payload and server response for debugging / UI
    // setSubmittedData({ payload, response: res?.data ?? null });

    // Close the loading modal
    Swal.close();

    // Confetti celebration
    try {
      confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 },
      });
    } catch (e) {
      // ignore confetti errors (e.g., SSR) — not critical
      console.warn('confetti error', e);
    }

    // Show success modal
    await Swal.fire({
      icon: 'success',
      title: 'Submitted!',
      text: '🎉 Your Upcoming Batch Registration request has been received. We will get back to you.',
      confirmButtonColor: '#8e44ad',
    });

    // Reset the form and local selection state
    form.resetFields();
    setCountryCode('+91'); // restore default country code
    // setSubmittedData(null); // clear the small preview (optional)
    setSelectedBatchKey(undefined);
    // (if you want to re-select first visible after reset, you can call setBatchSelection as you used elsewhere)

    // If parent onSubmit exists, call it and await if it returns a Promise
    // if (typeof onSubmit === 'function') {
    //   const ret = onSubmit(payload, endpoint, res?.data);
    //   if (ret && typeof ret.then === 'function') {
    //     await ret;
    //   }
    // }
  } catch (err) {
    console.error('submit error', err);

    // ensure loading modal is closed
    Swal.close();

    const errMsg = err?.response?.data?.message || err.message || 'Submission failed';

    // show both SweetAlert error and antd message
    await Swal.fire({
      icon: 'error',
      title: 'Submission failed',
      text: errMsg,
      confirmButtonColor: '#e74c3c',
    });
    message.error(`Submission failed: ${errMsg}`);

    // also keep error in submittedData for debugging if you want
    
  }
};



  const phoneValidator = (_, value) => {
    const digits = onlyDigits(value);
    if (!digits) return Promise.reject(new Error('Please enter phone number'));
    if (digits.length < 7 || digits.length > 15) return Promise.reject(new Error('Phone number must be 7-15 digits'));
    return Promise.resolve();
  };

  const getStatus = (name) => {
    const fieldErrors = form.getFieldError(name);
    const touched = form.isFieldTouched(name);
    if (fieldErrors && fieldErrors.length) return 'error';
    if (touched && (!fieldErrors || fieldErrors.length === 0)) return 'success';
    return undefined;
  };

  const onQualificationChange = () => form.setFieldsValue({ branch: undefined });

  return (
    <div className="w-full max-w-3xl p-5 mx-auto bg-gray-100 border-2 border-black shadow-2xl sm:p-6 rounded-2xl">
      <div className="p-3 mb-6 text-center bg-white border border-indigo-300 rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.06)] backdrop-blur-sm">
  <h2 className="text-2xl font-extrabold text-black sm:text-2xl md:text-3xl drop-shadow">
    Register Now
  </h2>

 
</div>






      <Form
        form={form}
        layout="vertical"
        initialValues={{ countryCode, requestCallback: 'NO' }}
        onFinish={onFinish}
        onValuesChange={(changed) => {
          if (changed.countryCode) setCountryCode(changed.countryCode);
          if (changed.batch) setSelectedBatchKey(changed.batch);
        }}
      >
        {/* contact */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <Form.Item
            name="fullName"
            label={<span className="text-base font-semibold text-black sm:text-lg">Full Name</span>}
            rules={[{ required: true, min: 2 }]}
            validateStatus={getStatus('fullName')}
            hasFeedback
          >
            <Input placeholder="Jane Doe" className="text-lg border-2 border-gray-400 rounded-lg shadow-sm sm:text-base focus:ring-2 focus:ring-blue-200" />
          </Form.Item>

          <Form.Item
            name="email"
            label={<span className="text-base font-semibold sm:text-lg text-slate-900">Email</span>}
            rules={[
              { required: true, message: 'Please enter your email' },
              { validator: (_, value) => (value && validateEmail(value) ? Promise.resolve() : Promise.reject(new Error('Enter a valid email')) ) },
            ]}
            validateStatus={getStatus('email')}
            hasFeedback
          >
            <Input placeholder="you@example.com" className="text-lg border-2 border-gray-400 rounded-lg shadow-sm sm:text-base focus:ring-2 focus:ring-blue-200" />
          </Form.Item>
        </div>

        {/* phone */}
        <div className="mt-3">
          <Form.Item label={<span className="text-base font-semibold sm:text-lg text-slate-900">Phone Number</span>}>
            <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center">
              <div className="w-full sm:w-44">
                <Form.Item name="countryCode" noStyle>
                  <Select style={{ width: '100%' }} value={countryCode} onChange={(val) => setCountryCode(val)} className="text-base border-2 border-gray-400 rounded-lg shadow-sm">
                    {COUNTRY_CODES.map(c => <Option key={c.code} value={c.code}>{`${c.name} (${c.code})`}</Option>)}
                  </Select>
                </Form.Item>
              </div>

              <div className="flex-1">
                <Form.Item name="phone" noStyle rules={[{ validator: phoneValidator }]} validateStatus={getStatus('phone')} hasFeedback>
                  <Input placeholder="Mobile number" className="w-full text-lg border-2 border-gray-400 rounded-lg shadow-sm sm:text-base focus:ring-2 focus:ring-blue-200" />
                </Form.Item>
              </div>
            </div>
          </Form.Item>
        </div>

        {/* Tabs */}
        <div className="mt-4">
          <Tabs activeKey={activeTab} onChange={(k) => setActiveTab(k)} destroyInactiveTabPane={false}>
            <TabPane tab={<span className="text-base font-medium sm:text-lg">Student</span>} key="student">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                {/* <Form.Item
                  name="qualification"
                  label={<span className="text-base font-semibold sm:text-lg text-slate-700">Qualification</span>}
                  rules={ activeTab === 'student' ? [{ required: true, message: 'Select qualification' }] : [] }
                  validateStatus={getStatus('qualification')}
                  hasFeedback
                >
                  <Select placeholder="Select qualification" onChange={onQualificationChange} className="text-base rounded-lg shadow-sm">
                    {QUALIFICATIONS.map(q => <Option key={q} value={q}>{q}</Option>)}
                  </Select>
                </Form.Item> */}

                {/* <Form.Item shouldUpdate={(prev, curr) => prev.qualification !== curr.qualification} noStyle>
                  {() => {
                    const qual = form.getFieldValue('qualification');
                    const options = qual ? (BRANCHES_BY_QUAL[qual] || []) : [];
                    return (
                      <Form.Item
                        name="branch"
                        label={<span className="text-base font-semibold sm:text-lg text-slate-700">Branch / Specialization</span>}
                        rules={ activeTab === 'student' ? [{ required: true, message: 'Select branch' }] : [] }
                        validateStatus={getStatus('branch')}
                        hasFeedback
                      >
                        <Select placeholder="Select branch" className="text-base rounded-lg shadow-sm">
                          {options.map(b => <Option key={b} value={b}>{b}</Option>)}
                        </Select>
                      </Form.Item>
                    );
                  }}
                </Form.Item> */}

                <Form.Item
                  name="collegeName"
                  label={<span className="text-base font-semibold sm:text-lg text-slate-900">College Name</span>}
                  rules={ activeTab === 'student' ? [{ required: true, message: 'Enter college' }] : [] }
                  validateStatus={getStatus('collegeName')}
                  hasFeedback
                >
                  <Input placeholder="College / University" className="text-lg border-2 border-gray-400 rounded-lg shadow-sm sm:text-base" />
                </Form.Item>

                <Form.Item
  name="passedOutYear"
  label={
    <span className="text-base font-semibold sm:text-lg text-slate-900">
      Passed Out Year / Pursuing Year
    </span>
  }
  rules={
    activeTab === "student"
      ? [
          { required: true, message: "Enter passed out year" },
          {
            pattern: /^[0-9]{4}$/,
            message: "Enter a valid 4-digit year",
          },
        ]
      : []
  }
  validateStatus={getStatus("passedOutYear")}
  hasFeedback
>
  <Input
    placeholder="e.g. 2024"
    maxLength={4}
    inputMode="numeric"
    className="text-lg border-2 border-gray-400 rounded-lg shadow-sm sm:text-base"
    onKeyPress={(e) => {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault(); // block non-numeric keys
      }
    }}
  />
</Form.Item>

              </div>
            </TabPane>

            <TabPane tab={<span className="text-base font-medium sm:text-lg">Professionals</span>} key="professional">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                {/* <Form.Item name="domain" label={<span className="text-base font-semibold sm:text-lg text-slate-700">Domain</span>}  rules={ activeTab === 'professional' ? [{ required: true, message: 'Select domain' }] : [] } validateStatus={getStatus('domain')} hasFeedback>
                  <Select placeholder="Select domain" className="text-base rounded-lg shadow-sm">
                    {DOMAINS.map(d => <Option key={d} value={d}>{d}</Option>)}
                  </Select>
                </Form.Item> */}

                {/* <Form.Item name="sector" label={<span className="text-base font-semibold sm:text-lg text-slate-700">Sector</span>}  rules={ activeTab === 'professional' ? [{ required: true, message: 'Enter sector' }] : [] } validateStatus={getStatus('sector')} hasFeedback>
                  <Input placeholder="e.g. Finance, Healthcare" className="text-lg border-gray-200 rounded-lg shadow-sm sm:text-base" />
                </Form.Item> */}

                <Form.Item name="companyName" label={<span className="text-base font-semibold sm:text-lg text-slate-900">Company Name</span>} rules={ activeTab === 'professional' ? [{ required: true, message: 'Enter company name' }] : [] } validateStatus={getStatus('companyName')} hasFeedback>
                  <Input placeholder="Enter Company Name" className="text-lg border-2 border-gray-400 rounded-lg shadow-sm sm:text-base" />
                </Form.Item>

                <Form.Item
  name="yearsOfExperience"
  label={
    <span className="text-base font-semibold sm:text-lg text-slate-900">
      No. Years Of Experience
    </span>
  }
  rules={
    activeTab === "professional"
      ? [{ required: true, message: "Enter years of experience" }]
      : []
  }
  validateStatus={getStatus("yearsOfExperience")}
  hasFeedback
>
  <Select
    placeholder="Select years"
    className="text-lg border-2 border-gray-400 rounded-lg shadow-sm sm:text-base"
  >
    {Array.from({ length: 11 }, (_, i) => (
      <Select.Option key={i} value={i}>
        {i}
      </Select.Option>
    ))}
  </Select>
</Form.Item>


                
              </div>
            </TabPane>
          </Tabs>
        </div>

        {/* Batch Day filter */}
        <div className="flex flex-col items-start gap-3 mt-6 mb-3 sm:flex-row sm:items-center">
          <label className="text-base font-bold text-black sm:text-lg">Batch Day</label>
          <Select value={batchDayFilter} onChange={(v) => setBatchDayFilter(v)} style={{ width: 220 }} className="text-base rounded-lg shadow-sm">
            <Option value="MORNING"><span className='font-semibold'>MORNING</span></Option>
            <Option value="EVENING"><span className='font-semibold'>EVENING</span></Option>
          </Select>
        </div>

        {/* Select Batch grid */}
        <div className="mt-1">
          <label className="block mb-2 text-base font-bold text-black sm:text-lg">Select Batch</label>

          <Form.Item name="batch" rules={[{ required: true, message: 'Select a batch' }]} validateStatus={getStatus('batch')} hasFeedback>
            {loadingBatches ? (
              <div className="flex justify-center py-6"><Spin /></div>
            ) : batchesError ? (
              <Alert type="error" message={`Failed to load batches: ${batchesError}`} />
            ) : displayedBatches.length === 0 ? (
              <div className="p-3 text-sm text-gray-600 rounded-lg bg-slate-50">No demo batches available for the next 3 months.</div>
            ) : (
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
                {displayedBatches.map(b => {
                  const selected = selectedBatchKey === b.key;
                  return (
                    <div
                      key={b.key}
                      role="button"
                      tabIndex={0}
                      onClick={() => setBatchSelection(b.key)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setBatchSelection(b.key); }}
                      className={`p-4 rounded-xl border transition-transform duration-150 cursor-pointer
                        ${selected ? 'border-blue-600 bg-gradient-to-br from-white to-blue-50 shadow-lg ring-2 ring-blue-200' : 'border-gray-200 hover:shadow-md hover:-translate-y-0.5 bg-white'}`}
                    >
                      <div className="flex items-center justify-between text-center">
                        <div className="text-lg font-bold sm:text-base md:text-xl text-slate-800">{b.label}</div>
                      </div>

                      <div className="flex flex-col gap-2 mt-3 text-sm sm:text-sm text-slate-700">
                        <div className="flex items-center gap-2">
                          <span className="font-bold text-slate-800">Time :</span>
                          <span className='font-bold text-blue-800'>{b.time || 'TBD'}</span>
                        </div>

                        <div className="flex items-center gap-2">
                          <span className="font-bold text-slate-800">Batch Start Date :</span>
                          <span className='font-bold text-green-600'>{b.batchStartIso ? dayjs(b.batchStartIso).format('DD MMM YYYY') : 'TBD'}</span>
                        </div>

                        <div className="flex items-center gap-2">
                          <span className="font-bold text-slate-800">Batch Day :</span>
                          <span className={`${b.batchDay === 'MORNING' ? 'text-amber-700 font-bold' : b.batchDay === 'EVENING' ? 'text-red-700 font-bold' : 'text-slate-600'}`}>{b.batchDay || '-'}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </Form.Item>
        </div>

        {/* Request a Call Back - shows only after a batch is selected */}
        {selectedBatchKey && (
          <div className="mt-4">
            <Form.Item
              name="requestCallback"
              label={<span className="text-base font-bold sm:text-lg text-slate-900">Get a Call Back From Our Experts</span>}
              rules={[]}
            >
              <Radio.Group>
                <Radio  value="YES"><span className='font-bold'>YES</span></Radio>
                <Radio value="NO" ><span className='font-bold'>NO</span></Radio>
              </Radio.Group>
            </Form.Item>
          </div>
        )}

        {/* submit / reset */}
        <div className="flex flex-col items-center justify-center gap-4 mt-8 sm:flex-row sm:gap-6">
  <Button
    type="primary"
    htmlType="submit"
    className="w-full py-6 text-xl font-bold transition-all duration-200 shadow-md sm:w-48 rounded-xl bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 focus:ring-4 focus:ring-purple-200"
    // loading={submitting}
    // disabled={submitting}
  >
    {/* {submitting ? 'Submitting...' : 'Submit'} */}
    Submit
  </Button>

  <Button
    onClick={() => {
      form.resetFields();
      setCountryCode('+91');
      // setSubmittedData(null);
      const visible = displayedBatches;
      if (visible.length) {
        setBatchSelection(visible[0].key);
      } else {
        setBatchSelection(undefined);
      }
    }}
    className="w-full py-6 text-xl font-bold text-white transition-all duration-200 shadow-md sm:w-48 rounded-xl bg-gradient-to-r from-green-500 to-gray-600 hover:from-indigo-600 hover:to-purple-700 focus:ring-4 focus:ring-purple-200"
  >
   Reset
  </Button>
</div>

      </Form>

      {/* {submittedData && (
        <div className="p-4 mt-6 border rounded-md bg-slate-50">
          <strong className="block mb-2 text-base">Submitted Data:</strong>
          <pre className="mt-2 text-sm whitespace-pre-wrap text-slate-700">{JSON.stringify(submittedData, null, 2)}</pre>
        </div>
      )} */}

    </div>
  );
}
